var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWand = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.453 7.25a.4.4 0 0 1 .517-.517L9.573 7.74a.4.4 0 0 0 .396-.062l2.166-1.76a.4.4 0 0 1 .651.332l-.152 2.786a.4.4 0 0 0 .182.358l2.343 1.515a.4.4 0 0 1-.114.723l-2.697.716a.4.4 0 0 0-.284.283l-.717 2.697a.4.4 0 0 1-.723.114L9.11 13.098a.4.4 0 0 0-.358-.183l-2.786.152a.4.4 0 0 1-.332-.652l1.76-2.165a.4.4 0 0 0 .064-.396L6.453 7.25z",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.28 3.965-.593-2.91m7.252 6.597 2.716-1.101M1.083 9.047l2.97.36m1.887 9.317 1.517-2.59",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "0.25 2.6"
}), /*#__PURE__*/React.createElement("path", {
  d: "m13.726 16.092 6.07 6.242c.565.58 1.489.602 2.08.051v0a1.486 1.486 0 0 0 .053-2.125l-6.042-6.212",
  strokeWidth: 1.75,
  strokeLinecap: "round"
}))));
export { SvgWand as Component };